<template>
    <div>
        <div v-if="question.options && question.options.items && question.options.items.length">
            <div v-for="(option, n) in question.options.items" v-bind:key="option.id" class="rate-container-option">
                <h4 :class="{'accepted': options_value[option.id] && (last_selected >= n), 'missing': !options_value[option.id] && (last_selected >= n)}">{{ option.label }}</h4>
                <div class="rate-container">
                    <div class="rate-container-buttons">
                        <div v-for="n in ((option.range ? (option.range.max - option.range.min) : (question.options.range.max - question.options.range.min)) + 1)" :class="{'included': (n + (option.range ? option.range.min : question.options.range.min) - 1) <= options_value[option.id], 'current': (n + (option.range ? option.range.min : question.options.range.min) - 1) == options_value[option.id] }">
                            <label>
                                <input type="radio" @change="update_done_status" :name="`${question.id}-${option.id}`" :id="`rate-${question.id}-${option.id}-${n + (option.range ? option.range.min : question.options.range.min) - 1}`" :value="n + question.options.range.min - 1" v-model="options_value[option.id]" />
                                <span>{{ n + question.options.range.min - 1 }}</span>
                            </label>
                            <div class="bar" @click="bar_click" :data-prev="n + question.options.range.min - 2" :data-next="n + question.options.range.min - 1"></div>
                        </div>
                    </div>
                    <div class="rate-labels">
                        <div class="rate-label"><label :for="`rate-${question.id}-${option.id}-${option.range ? option.range.min : question.options.range.min}`">{{ option.range ? option.range.min_label : question.options.range.min_label }}</label></div>
                        <div class="rate-label"><label :for="`rate-${question.id}-${option.id}-${option.range ? option.range.max : question.options.range.max}`">{{ option.range ? option.range.max_label : question.options.range.max_label }}</label></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="rate-container" v-else>
            <div class="rate-container-buttons">
                <div v-for="n in ((question.options.range.max - question.options.range.min) + 1)" :class="{'included': (n + (question.options.range.min) - 1) <= options_value[option.id], 'current': (n + question.options.range.min - 1) == value }">
                    <label>
                        <input type="radio" @change="update_done_status" :name="`${question.id}`" :id="`rate-${question.id}-${n + (question.options.range.min) - 1}`" :value="n + question.options.range.min - 1" v-model="value" />
                        <span>{{ n + question.options.range.min - 1 }}</span>
                    </label>
                    <div class="bar" @click="bar_click" :data-prev="n + question.options.range.min - 2" :data-next="n + question.options.range.min - 1"></div>
                </div>
            </div>
            <div class="rate-labels">
                <div class="rate-label"><label :for="`rate-${question.id}-${question.options.range.min}`">{{ question.options.range.min_label }}</label></div>
                <div class="rate-label"><label :for="`rate-${question.id}-${question.options.range.max}`">{{ question.options.range.max_label }}</label></div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'RateControl',
    props: ['question', 'callback'],
    data: function(){
      const multi = this.$props.question.options && this.$props.question.options.items && this.$props.question.options.items.length;
      return {
        'last_selected': -1,
        'value': multi ? null : (this.$props.question.value ? this.$props.question.value : null),
        'options_value': multi ? (this.$props.question.value ? this.$props.question.value : {}) : {},
      }
    },
    methods: {
      'update_done_status': function () {
        let status = false;
        if (this.$props.question.options && this.$props.question.options.items && this.$props.question.options.items.length){
          this.$props.question.value = this.$data.options_value;
          status = Object.values(this.$props.question.value).length >= this.$props.question.options.items.length;
        } else {
          this.$props.question.value = this.$data.value;
          status = this.$props.question.value !== undefined && this.$props.question.value !== null;
        }
        this.$emit('answered', {
          'status': status,
          'id': this.$props.question.id,
          'value': this.$props.question.value,
        });
        this.count_last_selected();
      },
      'count_last_selected': function () {
        let last_selected = -1;
        for (let i in this.$props.question.options.items){
          if (this.$props.question.value[this.$props.question.options.items[i]['id']]){
            last_selected = i;
          }
        }
        this.$data.last_selected = last_selected;
      },
      'bar_click': function (e) {
        if (!e.target.classList.contains('bar')){
          return;
        }
        const prev = parseInt(e.target.getAttribute('data-prev'));
        const next = parseInt(e.target.getAttribute('data-next'));
        const xc = e.clientX;
        const x0 = e.target.getBoundingClientRect().x;
        const x1 = x0 + e.target.getBoundingClientRect().width;
        const value = (((x1 + x0) / 2) < xc) ? next : prev;
        e.target.parentElement.parentElement.parentElement.querySelector(`[value="${value}"]`).click();
      }
    }
  }
</script>

<style scoped>

    .rate-container .rate-label {
        width: 50%;
        text-align: center;
        line-height: 1rem;
        padding-top: 0.25rem;
        color: #8a8a8a;
        font-size: 0.8rem;
    }
    .rate-container .rate-labels {
        display: flex;
    }
    .rate-container .rate-labels > .rate-label:first-child {
        text-align: left;
    }
    .rate-container .rate-labels > .rate-label:last-child {
        text-align: right;
    }


    .rate-container-buttons {
        display: flex;
        padding: 1rem 0;
        margin: 0 1rem;
    }
    .rate-container-buttons > div {
        width: 100%;
        text-align: center;
        position: relative;
    }
    .rate-container-buttons > div:first-child {
        width: 0;
    }
    .rate-container-buttons > div > .bar {
        cursor: pointer;
        background: #dddddd;
        height: 0.35rem;
    }
    rate-container-buttons > div:first-child > .bar {
        display: none;
    }
    .rate-container-buttons > div.included > .bar {
        background: #8fbd52;
    }
    .rate-container-buttons > div > label {
        position: absolute;
        z-index: 2;
        right: -1rem;
        bottom: -0.825rem;
        overflow: hidden;
        width: 2rem;
        height: 2rem;
        box-sizing: border-box;
        border-radius: 10rem;
        color: #8a8a8a;
        background: #ffffff;
        border: 0.25rem solid #dddddd;
        line-height: 1.5rem;
        font-weight: bold;
        transition: box-shadow 0.1s linear;
        box-shadow: 0 0 0 0 #8fbd52;
    }

    .rate-container-buttons > div > label > input {
        display: none;
    }

    .rate-container-buttons > div.included > label {
        border-color: #8fbd52;
        background: #ffffff;
        color: #8fbd52;
    }

    .rate-container-buttons > div.current > label {
        background: #8fbd52;
        color: #ffffff;
        box-shadow: 0 0 0 0.1rem #8fbd52;
    }

    .rate-container-option {
        margin-bottom: 1rem;
    }
    .rate-container-option h4 {
        text-align: center;
        margin-bottom: 0.35rem;
        font-size: 1.2rem;
    }
    .rate-container-option h4.missing {
        color: #ea9502;
    }
    .rate-container-option h4.accepted {
        color: #8fbd52;
    }
    .rate-container-option .rate-label {
        visibility: hidden;
        text-transform: uppercase;
    }
    .rate-container-option:hover .rate-label {
        visibility: visible;
    }
    @media only screen and (max-width: 1024px) {
        .rate-container-option .rate-label {
            visibility: visible;
        }
    }

    @media only screen and (min-width: 1024px) {
        .rate-container-option {
            display: flex;
            padding-bottom: 1rem;
            border-bottom: 1px solid #dddddd;
        }

        .rate-container-option h4 {
            width: 35%;
            font-size: 1.1rem;
            padding-top: 0.5rem;
            padding-right: 2rem;
            box-sizing: border-box;
            text-align: left;
            line-height: 1rem;
            margin-bottom: 0;
        }
        .rate-container-option .rate-container {
            width: 65%;
        }
    }
</style>
